import { isStr, isObj } from '../../utils';
import initialState from '../initialState';

const isValid = (theme) => isObj(theme) && isStr(theme.mode);

const initState = (initialState) => {
  if (!isValid(initialState)) {
    throw Error('Invalid initial theme state');
  }

  return {
    mode: initialState.mode,
  };
};

export const getters = {
  mode: ({ mode }) => mode,
};

const actions = {
  setMode: ({ commit }, mode) => {
    commit('SET', mode);
  },
  reset: ({ commit }) => commit('SET', initialState.theme.mode),
};

const mutations = {
  SET(state, mode) {
    /* eslint-disable no-param-reassign */
    state.mode = mode;
  },
};

export default (initialState) => ({
  namespaced: true,
  state: initState(initialState),
  getters,
  actions,
  mutations,
});
